import { useState, useEffect, useRef } from 'react';
import {
  BottomSheetBox,
  ToggleButton,
  ToggleArrow,
  BoxText,
} from 'styles/components/common/BottomSheetStyle';
import Arrow from 'assets/icons/toggle-arrow.svg';
import { ButtonSolid } from 'styles/common/ButtonStyle';
import { BoxColumnWrapper } from 'styles/common/BoxStyle';
import { openExternalLink } from 'utils/helper';

function MyBottomSheet() {
  const [open, setOpen] = useState(false);
  const [sheetHeight, setSheetHeight] = useState(0);
  const sheetRef = useRef(null);

  const toggle = () => setOpen((prev) => !prev);

  // 실제 height 추적
  useEffect(() => {
    if (sheetRef.current) {
      const updateHeight = () => {
        setSheetHeight(sheetRef.current.clientHeight);
      };

      updateHeight(); // 최초
      window.addEventListener('resize', updateHeight); // 리사이즈 대응

      return () => {
        window.removeEventListener('resize', updateHeight);
      };
    }
  }, [open]);

  return (
    <>
      <ToggleButton
        onClick={toggle}
        open={open}
      >
        <ToggleArrow
          src={Arrow}
          alt="toggle arrow"
          style={{ transform: open ? 'rotate(0deg)' : 'rotate(60deg)' }}
        />
      </ToggleButton>

      <BottomSheetBox 
              style={{
                bottom: `${open ? 66 : -sheetHeight+66}px`, // 열린 상태면 바텀시트 위, 닫히면 기본 위치
              }}      
      ref={sheetRef}>
        <BoxColumnWrapper count={2} height="none">
          <BoxText size="14px" weight="500">
            100% 페이백 안내
          </BoxText>
          <ButtonSolid
            fontSize="12px"
            fontWeight="500"
            width="120px"
            height="30px"
            marginBottom="10px"
            onClick={(e) => {
              e.preventDefault();
              openExternalLink('https://www.cpoint.or.kr/netzero/main.do');
            }}
          >
            참여신청 바로가기
          </ButtonSolid>
        </BoxColumnWrapper>
        <BoxText size="12px">
          환경부는 회원님에게{' '}
          <span class="red-text">
            익월말 2천원/ 1회당(7만원/년 한도)
          </span>
          을 돌려드립니다. <br />
          단, '탄소중립포인트 녹색생활실천'에 회원가입과 참여신청을 하셔야 합니다.<br />
          <br />
          *예산소진시, 예산 추가 확보후 소급적용하여 일괄 지급됩니다. 자세한 사항은
          '탄소중립포인트 녹색생활실천' 안내 콜센터로 문의바랍니다.
        </BoxText>
      </BottomSheetBox>
    </>
  );
}

export default MyBottomSheet;
